var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TagSelectBloc',{attrs:{"title":_vm.$t('user.userSkills.interests'),"action-label":_vm.$t('user.userSkills.addInterest'),"tags":_vm.allInterests,"user-tags":_vm.editable ? _vm.editedInterests : _vm.interests,"editable":_vm.editable,"allow-new-values":false,"on-select":_vm.addInterest,"on-delete":_vm.removeInterest}})
}
var staticRenderFns = []

export { render, staticRenderFns }